import { api } from "./api";

const SID_KEY = "psc_sid";

export function getSessionId() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (crypto?.randomUUID?.() || String(Date.now()) + Math.random().toString(36).slice(2));
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

// Fire an internal analytics event + forward to GA4 / Meta Pixel when available.
export function track(type, payload = {}) {
  const body = { type, session_id: getSessionId(), ...payload };
  api.post("/track", body).catch(() => {});

  const gtag = window.gtag;
  const fbq = window.fbq;
  try {
    if (typeof gtag === "function") {
      const map = {
        product_view: "view_item",
        add_to_cart: "add_to_cart",
        checkout: "begin_checkout",
        search: "search",
        page_view: "page_view",
      };
      const ev = map[type];
      if (ev) gtag("event", ev, { items: payload.product_name ? [{ item_name: payload.product_name }] : undefined, value: payload.value || undefined, search_term: payload.query || undefined });
    }
    if (typeof fbq === "function") {
      const map = {
        product_view: "ViewContent",
        add_to_cart: "AddToCart",
        checkout: "InitiateCheckout",
        search: "Search",
      };
      const ev = map[type];
      if (ev) fbq("track", ev, { content_name: payload.product_name, value: payload.value || undefined, currency: "CRC", search_string: payload.query || undefined });
    }
  } catch { /* noop */ }
}

let injected = false;
// Inject GA4, Google Ads and Meta Pixel scripts once, based on settings IDs.
export function initAdsTracking(settings = {}) {
  if (injected || typeof document === "undefined") return;
  const { ga4_id, google_ads_id, meta_pixel_id } = settings;
  if (!ga4_id && !google_ads_id && !meta_pixel_id) return;
  injected = true;

  if (ga4_id || google_ads_id) {
    const primary = ga4_id || google_ads_id;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${primary}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    if (ga4_id) window.gtag("config", ga4_id);
    if (google_ads_id) window.gtag("config", google_ads_id);
  }

  if (meta_pixel_id) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", meta_pixel_id);
    window.fbq("track", "PageView");
    /* eslint-enable */
  }
}
